import { ScanSearch, MessagesSquare, UserRound, Home } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';
import { WHY_ITEMS, IMAGES } from '../config/site';

const ICONS = {
  scan: ScanSearch,
  chat: MessagesSquare,
  user: UserRound,
  home: Home,
};

const ICON_TINTS = ['text-electric', 'text-aqua', 'text-fresh', 'text-electric'];

export const WhyKindstone = () => (
  <section id="why-kindstone" className="ks-why scroll-mt-24 overflow-hidden py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:gap-20 lg:px-8">
      <div>
        <Reveal>
          <Eyebrow>Why KINDSTONE</Eyebrow>
          <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            The KINDSTONE Difference
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-charcoal sm:text-lg">
            Quality-led service, honest communication and a genuine care for your home — that's what
            KINDSTONE stands for, from the first quote to every visit.
          </p>
        </Reveal>

        <ul className="mt-10 space-y-3">
          {WHY_ITEMS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={i * 0.08}>
                <li
                  className="flex items-start gap-5 rounded-2xl border border-navy/10 bg-white/85 px-5 py-6 shadow-soft sm:px-6"
                  data-testid={`why-item-${i + 1}`}
                >
                  <span className="flex items-baseline gap-4">
                    <span className="text-sm font-extrabold tabular-nums text-charcoal/40">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </span>
                  <div className="flex-1">
                    <h3 className="flex items-center gap-2.5 text-lg font-bold text-navy sm:text-xl">
                      <Icon size={19} className={ICON_TINTS[i]} strokeWidth={2} aria-hidden="true" />
                      {item.title}
                    </h3>
                    <p className="mt-1.5 max-w-md text-sm leading-relaxed text-charcoal sm:text-base">
                      {item.description}
                    </p>
                  </div>
                </li>
              </Reveal>
            );
          })}
        </ul>
      </div>

      <Reveal className="relative order-first lg:order-last">
        <div className="relative overflow-hidden rounded-[2.5rem] shadow-lift">
          <img
            src={IMAGES.cleanerTowels}
            alt="A KINDSTONE professional cleaning the mirror of a bright residential bathroom"
            className="h-[400px] w-full object-cover sm:h-[540px] lg:h-[620px]"
            loading="lazy"
          />
        </div>
        <div
          className="pointer-events-none absolute -bottom-10 -right-10 -z-10 h-64 w-64 rounded-full bg-fresh/15 blur-2xl"
          aria-hidden="true"
        />
      </Reveal>
    </div>
  </section>
);

export default WhyKindstone;
